import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import Close, { StylesCloseVariables } from './Close';
import { StylesModalVariables } from './Modal';
import { jsx as ___EmotionJSX } from "@emotion/react";

const ModalHeader = _ref => {
  let {
    centered,
    className,
    setIsOpen,
    title
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["centered", "className", "setIsOpen", "title"]);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: [{
      display: 'grid',
      gridTemplateColumns: centered ? StylesCloseVariables(theme).size + "px 1fr " + StylesCloseVariables(theme).size + "px" : "1fr " + StylesCloseVariables(theme).size + "px",
      gap: theme.space.small,
      padding: StylesModalVariables(theme).padding
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;"],
    className: clsx('CK__ModalHeader', className)
  }, rest), ___EmotionJSX("h4", {
    css: ["margin-bottom:0;", centered && {
      gridColumn: 2,
      textAlign: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;"]
  }, title), ___EmotionJSX(Close, {
    onClick: () => setIsOpen(false),
    css: [centered && {
      gridColumn: 3
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;"]
  }));
};

export default ModalHeader;